import { Component } from '@angular/core';

@Component({
  template: `<em>Field type not supported</em>`
})
export class UnsupportedFieldComponent {}
